import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "copyright" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "mt-2 mt-lg-0" }, "Developed by Tom Alderson", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BCol = _resolveComponent("BCol")!
  const _component_BContainer = _resolveComponent("BContainer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BContainer, { fluid: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_BCol, { class: "d-flex justify-content-between align-items-center p-3 flex-column flex-lg-row" }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: _ctx.logo,
              alt: "TomAldy Logo"
            }, null, 8, _hoisted_2),
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}